import { Component, Input, OnInit } from '@angular/core';
import { HttpService } from '../../../../core';
import { ToastrService } from 'ngx-toastr';
import { AddDocumentDialogComponent } from './add-document-dialog/add-document-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DeleteConfirmDialogComponent } from './delete-confirm-dialog/delete-confirm-dialog.component';
import { environment } from '../../../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
@Component({
    selector: 'app-project-documents',
    templateUrl: './documents.component.html',
    styleUrls: ['./documents.component.scss']
})

export class DocumentsComponent implements OnInit {

    @Input() project: any;
    VERIFICATION_CODE_URL = environment.VERIFICATION_CODE_URL;

    termsForm: any;

    selected = 'any';
    selectList: any[] = ['any', 'Activated', 'Deactivated', 'A - Z']

    displayedColumnsForTerms: string[] = ['fileName', 'uploadUser', 'uploadTime', 'action'];
    displayedColumnsForProject: string[] = ['fileName', 'uploadUser', 'uploadTime', 'action'];
    dataSourceForTerms: any[] = [];
    dataSourceForProject: any[] = [];
    dataSourceForEoi: any[] = [];
    keywords = '';
    isFiltered = false;
    projectId: string;

    SERVER_URL = environment.SERVER_URL;

    constructor(
        private httpService: HttpService,
        private toastr: ToastrService,
        private route: ActivatedRoute,
        private dialog: MatDialog) {
        this.projectId = this.route.snapshot.paramMap.get('id');
    }

    ngOnInit(): void {
        this.httpService.getProjectDetailByProjectId(this.projectId).toPromise().then((projectDetail: any) => {
            this.project = projectDetail.data;

            this.dataSourceForTerms = this.project.termFiles;
            this.dataSourceForProject = this.project.documentFiles;
            if (this.project.eoiFile) {
                this.dataSourceForEoi.push(this.project.eoiFile)
            }
        });
    }

    openDeleteConfirmDialog(fileId, fileType) {
        const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
            width: '400px',
            data: { fileId: fileId, project: this.project, fileType: fileType }
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
            if (result && result.fileId) {
                result.showBox = false

                if (result.fileType == 'terms') {
                    this.project.termFiles = this.project.termFiles.filter((file => {
                        return file.id !== result.fileId;
                    }));
                } else if (result.fileType === 'project') {
                    this.project.documentFiles = this.project.documentFiles.filter((file => {
                        return file.id !== result.fileId;
                    }));
                }
                else if (result.fileType === 'eoi') {
                    console.log(result,'eoi');
                    this.dataSourceForEoi = []
                    this.project.eoiFile = null;
                    this.ngOnInit()
                    return
                }

                this.filterData()
            }
        });
    }

    getFileUrl(fileName, prefix) {
        return encodeURI(this.SERVER_URL + 'files/' + this.project.projectCode + '/' + prefix + '/' + fileName);
    }

    getEoiFileUrl(fileName, prefix) {
        return encodeURI(this.SERVER_URL + 'files/' + this.project.projectCode + '/' + prefix + '/' + fileName);
    }

    openFile(fileName, prefix) {
        window.open(this.getFileUrl(fileName, prefix));
    }

    openEoiFileUrl(fileName, prefix) {
        window.open(this.getEoiFileUrl(fileName, prefix));
    }

    filterData() {
        this.dataSourceForProject = this.project.documentFiles.filter((file) => {
            return file.fileName.toLowerCase().includes(this.keywords.toLowerCase());
        });
        this.dataSourceForTerms = this.project.termFiles.filter((file) => {
            return file.fileName.toLowerCase().includes(this.keywords.toLowerCase());
        });
        this.dataSourceForEoi = []
        if (this.project.eoiFile && this.project.eoiFile.fileName.toLowerCase().includes(this.keywords.toLowerCase())) {
            this.dataSourceForEoi.push(this.project.eoiFile)
        }

        this.isFiltered = this.keywords !== '';
    }

    deleteEoiFile() {
        this.httpService.deleteEoiFile(this.project.id).subscribe((res) => {
            console.log(this.project, 'project1111');
            // this.dataSourceForEoi = []
            // this.project.eoiFile = null;
            this.ngOnInit();
            console.log(this.project, 'project2222');
        });
    }
}
